import React, { SetStateAction, useState } from 'react';
import { Button } from 'react-bootstrap';
import { Pen, Trash } from 'react-bootstrap-icons';
import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import ConfirmationModal from '../../../shared/components/ConfirmationModal';
import EmptyTable from '../../../shared/components/EmptyTable';
import { formatNumber } from '../../../shared/functions/formatNumber';
import { handleError } from '../../../shared/functions/handleError';
import { ITruckBrand } from '../../../shared/interfaces/ITruck';
import { AdminTruckBrandService } from '../service';

interface IProps {
  truckBrands: ITruckBrand[];
  isAdmin?: boolean;
  reset: UseFormReset<ITruckBrand>;
  setIsActionModalOpened: React.Dispatch<SetStateAction<boolean>>;
  handleUpdateList: () => void;
}

const TruckBrandTable = ({
  truckBrands,
  isAdmin,
  reset,
  handleUpdateList,
  setIsActionModalOpened,
}: IProps) => {
  const { t } = useTranslation();
  const [isDeleteOpened, setIsDeleteOpened] = useState(false);
  const [selectedTruckBrand, setSelectedTruckBrand] = useState<
    ITruckBrand | undefined
  >(undefined);
  const handleCancelDelete = () => {
    setSelectedTruckBrand(undefined);
    setIsDeleteOpened(false);
  };
  const handleConfirmDelete = async () => {
    !!selectedTruckBrand?.id &&
      (await AdminTruckBrandService.delete(selectedTruckBrand?.id)
        .then((response) => {
          if (response) {
            handleUpdateList();

            handleCancelDelete();
            toast.success(
              t('toast.successDelete', { name: selectedTruckBrand?.name }),
            );
          }
        })
        .catch(handleError));
  };
  return (
    <>
      <div className="table-responsive">
        <table className="table ">
          <thead className="table-dark">
            <tr>
              <th scope="col">#</th>
              <th scope="col">{t('general.name')}</th>
              <th scope="col">{t('general.firstServiceKm')}</th>
              <th scope="col">{t('general.majorServiceIntervalKm')}</th>
              <th scope="col">{t('general.minorServiceIntervalKm')}</th>
              {isAdmin && <th scope="col">{t('general.actions')}</th>}
            </tr>
          </thead>
          <tbody className={'border'}>
            {!!truckBrands?.length ? (
              truckBrands?.map((truckBrand) => {
                return (
                  <tr key={truckBrand?.id}>
                    <td>{truckBrand?.id}</td>
                    <td>{truckBrand?.name}</td>
                    <td>{formatNumber(truckBrand?.firstServiceKm)}</td>
                    <td>{formatNumber(truckBrand?.majorServiceIntervalKm)}</td>
                    <td>{formatNumber(truckBrand?.minorServiceIntervalKm)}</td>
                    {isAdmin && (
                      <td>
                        <>
                          <Button
                            variant={'warning'}
                            size={'sm'}
                            onClick={() => {
                              reset(truckBrand);
                              setIsActionModalOpened(true);
                            }}
                          >
                            <Pen />
                          </Button>
                        </>
                        <Button
                          variant={'danger'}
                          className={'ms-2'}
                          size={'sm'}
                          onClick={() => {
                            setSelectedTruckBrand(truckBrand);
                            setIsDeleteOpened(true);
                          }}
                        >
                          <Trash />
                        </Button>
                      </td>
                    )}
                  </tr>
                );
              })
            ) : (
              <EmptyTable columns={6} />
            )}
          </tbody>
        </table>
      </div>
      <ConfirmationModal
        name={selectedTruckBrand?.name}
        isActionModalOpened={isDeleteOpened}
        handleConfirmDeletion={handleConfirmDelete}
        handleCloseActionModal={handleCancelDelete}
      />
    </>
  );
};

export default TruckBrandTable;
